<div style="margin: 20px; width: 1200px; height: 700px;  ">
  <p-tabView>
    <p-tabPanel header="Dostęp do walidacji" *ngIf="isUserInRoles(['AdministratorRole','ValidationOperatorRole'])">
      <p-table [value]="configs" [paginator]="true" [rows]="limit">
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;">
            <th width="50">L.p.</th>
            <th width="160">Nazwa</th>
            <th width="240">Walidator</th>
            <th>Opis</th>
            <th width="120">Zaznaczenie</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-config let-rowIndex="rowIndex">
          <tr style="white-space: normal; overflow-wrap: break-word;">
            <td>{{rowIndex + 1}}</td>
            <td>{{config.name}}</td>
            <td>{{config.validationProvider.label}}</td>
            <td>{{config.description}}</td>
            <td>
              <p-checkbox name="selected" [(ngModel)]="selected" [value]="config"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div>
        <span style="float: right;">
          <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
          <p-button class="button" (click)="save()" label="Zapisz"></p-button>
        </span>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Rezerwacje - firmy najemców" *ngIf="isUserInRoles(['AdministratorRole','ReservationOperatorRole'])">
      <div *ngFor="let company of companies" style="margin-bottom: 20px;">
        <p-checkbox name="reservationCompanies" [(ngModel)]="reservationCompanies" [value]="company.id" label="{{company.name}}"></p-checkbox>
      </div>
      <div>
        <span style="float: right;">
          <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
          <p-button class="button" (click)="saveReservationCompanies()" label="Zapisz"></p-button>
        </span>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Hot Parking - firmy najemców" *ngIf="isUserInRoles(['AdministratorRole','HotParkingOperatorRole'])">
      <div *ngFor="let company of companies" style="margin-bottom: 20px;">
        <p-checkbox name="hotParkingCompanies" [(ngModel)]="hotParkingCompanies" [value]="company.id" label="{{company.name}}"></p-checkbox>
      </div>
      <div>
        <span style="float: right;">
          <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
          <p-button class="button" (click)="saveHotParkingCompanies()" label="Zapisz"></p-button>
        </span>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
